import { Component } from 'react'
import { withRouter } from 'hocs'
import { connect } from 'react-redux'
import * as ACT from 'components/proposals/Proposal/actions'
import { Details } from './Details'

@withRouter
@connect()
class DetailsContainer extends Component {
  updateProposal = proposal => {
    this.props.dispatch({
      type: ACT.PROPOSAL_UPDATE_REQUESTED,
      payload: {
        proposal
      }
    })
  }

  approveProposal = () => {
    this.props.dispatch({
      type: ACT.PROPOSAL_APPROVE_REQUESTED,
      payload: {
        id: this.props.proposal?.id
      }
    })
  }

  deleteProposal = () => {
    this.props.dispatch({
      type: ACT.PROPOSAL_DELETE_REQUESTED,
      payload: {
        id: this.props.proposal?.id,
        navigate: this.props.router.navigate,
        dealId: this.props.proposal.deal.id
      }
    })
  }

  render() {
    const {
      proposal,
      assignees,
      router,
      toggleScheduleTaskModal,
      toggleSendForInternalReviewModal,
      clientContacts
    } = this.props
    const { id } = router.params
    const { deal } = proposal
    return (
      <section>
        <Details
          proposalId={id}
          proposal={proposal}
          assignees={assignees}
          updateProposal={this.updateProposal}
          approveProposal={this.approveProposal}
          deleteProposal={this.deleteProposal}
          dealName={deal.name}
          toggleScheduleTaskModal={toggleScheduleTaskModal}
          toggleSendForInternalReviewModal={toggleSendForInternalReviewModal}
          clientContacts={clientContacts}
        />
      </section>
    )
  }
}

export default DetailsContainer
